import React, { useState, useEffect } from "react";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  Tab,
  Add,
} from "@mui/icons-material";
import axiosInstance from "../../../lib/axios";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../../Auth";
import UnLock from "../../../GlobalFunction/UnLock";

import {
  Stepper, Step, StepLabel,
  InputLabel, Select, MenuItem, Autocomplete
} from '@mui/material';
import { FormLabel, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
const columns = [
  { id: 'Addr', label: 'Address', minWidth: 10 },
  { id: 'GsttinNo', label: 'GstNo', minWidth: 10 },
  { id: 'AreaName', label: 'Area', minWidth: 10 },
  { id: 'MobileNo', label: 'Mobile', minWidth: 10 },
  { id: 'ContactPerson', label: 'ContactPerson', minWidth: 10 },
  { id: "DBFLAG", label: "Flag", minWidth: 50 },

];



const PartyStepper2 = ({ GridData, setActiveStep, setGridData, Company, AllfieldStepperData, Mode, PartyId, fetchPartyData, AllButtonTextDisabled, UserId, Category, setCategory, setAllButtonTextDisabled }) => {

  const { register, setValue, reset, watch } = useForm();
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
  const [IndexofSelect, setIndexofSelect] = useState(0);
  const [InternalMode, setInternalMode] = useState("add");
  const [AddDisabled, setAddDisabled] = useState(false);
  const [PinCity, setPinCity] = useState([]);
  const [openDialog, setopenDialog] = useState(false);
  console.log("watch()", watch());

  useEffect(() => {

    if (PinCity.length > 0) {
      handlePinIdChange();
    }

  }, [PinCity])

  useEffect(() => {
    if (IndexofSelect === -1) return;
    fieldValue();
    setAllTextDisabled(true);
  }, [IndexofSelect, GridData])



  const settingValue = () => {
    handlePincodeChange();
  }



  const fieldValue = () => {
    console.log("TableData", GridData);
    let obj = GridData[IndexofSelect];
    for (let key in obj) {
      setValue(key, obj[key]);
    }
    settingValue();
  }


  const resetFunc = () => {
    reset(
      {
        "Addr": "",
        "PartyAbrv": "",
        "PartyAltCode": "",
        "GsttinNo": "",
        "AreaName": "",
        "PinCode": "",
        "PinId": "",
        "City": "",
        "State": "",
        "PanNo": "",
        "TanNo": "",
        "IeCode": "",
        "Website": "",
        "TelNo": "",
        "Email": "",
        "ContactPerson": "",
        "MobileNo": "",
        "WorkAdd": "",
        "MsmeNo": "",
        "MsmeAct": "N",
        "MsmeTr": "N",
        "MsmeClass": "N",
        "Remark": "",
        "PartyId": "",
        "MainBranch": "",
        "RegAdd": "",
        "Sst": "",
        "Cst": "",
        "ExciseCode": "",
        "Vat": "",
        "SmsMobileno": "",
        "AccledId": "",
        "RdUrd": "",
        "MsmeFlag": "",

      }
    )
  }

  const handlePinIdChange = async () => {
    console.log('PinId', watch('PinId'));
    if (watch('PinId') === undefined || watch('PinId') === '') return;
    let getObj = PinCity.find(obj => obj.Id === watch('PinId'));
    console.log("getobj ", getObj);
    let AreaName = getObj?.Name;
    let PinCode = getObj?.PinCode;
    if (getObj) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodeAreawise_datafill`,
          {
            AreaName,
            PinCode
          },

        );
        const data = response.data.Data;
        console.log("pindata", data);
        if (data && data.length > 0) {
          setValue('City', data[0].CityName);
          setValue('State', data[0].StateName);
        } else {

        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    }

  }

  const handlePincodeChange = async () => {
    if (watch('PinCode') === undefined || watch('PinCode') === '') return;
    let value = watch("PinCode");
    console.log("value", value);
    if (value.length === 6) {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}pincodeMst/getdrppincodewisearea`,
          {
            PinCode: parseInt(value),
          },

        );
        const data = response.data.Data;

        if (data && data.length > 0) {
          setPinCity(data);


        } else {
          setPinCity([]);
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    } else {
      setValue("City", "");
      setValue("State", "");
      setPinCity([]);
    }

  }



  const handleClickAdd = () => {
    setInternalMode("Add");
    setAllTextDisabled(false);
    resetFunc();
    setIndexofSelect(-1);
    setAllButtonDisabled(true);
    setAddDisabled(true);
  };

  const handleClickEdit = () => {
    setInternalMode("Edit")
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
    setAddDisabled(true);
  };

  const handleRowClick = (rowIndex) => {
    setIndexofSelect(rowIndex);
    if (rowIndex == 0) {
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      return;
    }
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
  };

  const handleClickConfirm = () => {
    let obj = watch();
    console.log(obj);

    if (obj.Addr === "" || obj.PinId === "" || obj.CityId === "" || obj.PinCode === "") {
      toast.info("Plz Filled the Data");
      return;
    };
    obj.CityId = parseInt(obj.CityId);
    obj.PinId = parseInt(obj.PinId);
    let ind = PinCity.findIndex(item => item.Id === obj.PinId);
    obj.AreaName = PinCity[ind].Name;
    console.log("Pincity", PinCity);

    let duplicateInd = GridData.findIndex(item => item.PinId === obj.PinId);
    if (InternalMode === "Add") {
      if (duplicateInd < 0) {
        obj.AccledId = 1;
        obj.PartyId = 1
        obj.DBFLAG = "I";
        obj.Status = "1";
        obj.MainBranch = "0";
        obj.RdUrd = AllfieldStepperData.RdUrd;
        obj.PartyCat = AllfieldStepperData.PartyCat;
        obj.CityId = 1; obj.CoMstId = 1;
        // let ind = PinCity.findIndex(item => item.Id === obj.PinId);
        // obj.AreaName = PinCity[ind].Name;
        let newTabData = [...GridData];
        newTabData.push(obj);
        setGridData(newTabData);
        setAllButtonDisabled(false);
        setAllTextDisabled(true);
        handleRowClick(0);
      } else {
        toast.error("Duplicate City");
      }
    } else {
      GridData[IndexofSelect].DBFLAG === "I" ? obj.DBFLAG = "I" : obj.DBFLAG = "U";
      let TabData = [...GridData];
      for (let key in obj) {
        TabData[IndexofSelect][key] = obj[key];
      }
      // TabData[IndexofSelect]['CobrLogo'] = selectedImage;
      setGridData(TabData);
      setAllButtonDisabled(false);
      setAllTextDisabled(true);
      handleRowClick(0);

    }




    // if (duplicateInd < 0) {
    //   if (InternalMode === "Add") {
    //     obj.CobrMstId = 0;
    //     obj.DBFLAG = "I";
    //     obj.Status = "1";
    //     obj.MainBranch = "0";
    //     let newTabData = [...TableData];
    //     newTabData.push(obj);
    //     setTableData(newTabData);
    //   } else {
    //     TableData[IndexofSelect].DBFLAG === "I" ? obj.DBFLAG = "I" : obj.DBFLAG = "U";
    //     let TabData = [...TableData];
    //     for (let key in obj) {
    //       TabData[IndexofSelect][key] = obj[key];
    //     }
    //     setTableData(TabData);
    //   }
    //   setAllButtonDisabled(false);
    //   setAllTextDisabled(true);
    // } else {
    //   toast.error("Duplicate Name")
    // }
  };




  const handlePreviousClick = () => {
    console.log("hii previos")
    if (!(!AllButtonDisabled || !AddDisabled)) {
      toast.info("Please Confirm Or Cancel The Request");
      console.log(!AllButtonDisabled || !AddDisabled);
      return;
    }
    setActiveStep(0);
  }

  function hasProperty(obj, property) {
    return property in obj;
  }

  const handleSubmit = async () => {
    console.log("AllFieldStepperDAta", AllfieldStepperData)
    if (!(!AllButtonDisabled || !AddDisabled)) {
      toast.info("Please Confirm Or Cancel The Request");
      console.log(!AllButtonDisabled || !AddDisabled);
      return;
    }
    setAllButtonTextDisabled(prev => !prev);

    AllfieldStepperData.RegAdd = "";
    AllfieldStepperData.Website = "";
    AllfieldStepperData.Sst = "";
    AllfieldStepperData.Cst = "";
    AllfieldStepperData.ExciseCode = "";
    AllfieldStepperData.Vat = "";
    AllfieldStepperData.SmsMobileno = "";
    AllfieldStepperData.CityId = 1;
    AllfieldStepperData.CoMstId = 1;
    AllfieldStepperData.Status = (AllfieldStepperData.Status === "1") ? "1" : "0";
    // let removeProp = ["City","State"];
    // for(let i = 0; i < removeProp.length; i++){
    //   if(hasProperty(AllfieldStepperData,removeProp[i])){
    //     delete GridData[i].removeProp[i];
    //   }
    // }
    if (Mode === "add") {
      AllfieldStepperData.DBFLAG = "I";
      AllfieldStepperData.CreatedBy = parseInt(UserId);

      for (let i = 1; i < GridData.length; i++) {
        if (hasProperty(GridData[i], "City")) {
          delete GridData[i].City;
        }
      }
      AllfieldStepperData.PartyMstDtlList = [...GridData];
      console.log("Stepper Field", AllfieldStepperData);
      console.log("GridData", GridData);
      let FormattedObj = JSON.stringify(AllfieldStepperData).replace(/"/g, '\\"');
      FormattedObj = '"' + FormattedObj + '"';

      console.log("formatted String ", FormattedObj)
      try {
        let response = await axiosInstance.post(
          `PartyMst/ManagePartyDtl`,
          FormattedObj,

        );
        console.log("response", response);
        toast.success(response.data.Message, { autoClose: 1000 });

        // fetchCompanyData(1,"L");
        fetchPartyData(1, "L", AllfieldStepperData.PartyCat);
        setActiveStep(0);

        // setTimeout(() => {
        //   navigate(`/masters/companytable`);
        // }, 1800);
      } catch (err) {
        console.log("err", err);
      }
      console.log(":add Mode");
    } else {
      AllfieldStepperData.DBFLAG = "U";
      AllfieldStepperData.PartyId = PartyId;
      AllfieldStepperData.UpdatedBy = parseInt(UserId);
      let sendObj = { ...AllfieldStepperData };
      let SendGridData = [...GridData];
      hasProperty(sendObj, "City") && delete sendObj.City;
      hasProperty(sendObj, "State") && delete sendObj.State;
      for (let i = 0; i < SendGridData.length; i++) {
        hasProperty(SendGridData[i], "City") && delete SendGridData[i].City;
        hasProperty(SendGridData[i], "State") && delete SendGridData[i].State;
      }


      sendObj = { ...sendObj, PartyMstDtlList: [...SendGridData] };
      console.log("send Data", sendObj);
      let FormattedObj = JSON.stringify(sendObj).replace(/"/g, '\\"');
      FormattedObj = '"' + FormattedObj + '"';

      try {
        let response = await axiosInstance.post(
          `PartyMst/ManagePartyDtl`,
          FormattedObj,

        );
        console.log("response", response);
        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(PartyId, "MstParty", "PartyId");

          fetchPartyData(PartyId, "R", AllfieldStepperData.PartyCat);
          setActiveStep(0);

        }

        // setTimeout(() => {
        //   navigate(`/masters/companytable`);
        // }, 1800);
      } catch (err) {
        console.log("err", err);
      }

      console.log(":view Mode");
    }

  }


  const handleDelete = () => {
    setopenDialog(true);

  }

  const handleCancel = () => {
    setopenDialog(false);
  }
  const handleConfirmDelete = () => {
    console.log(IndexofSelect);
    let TabData = [...GridData];
    let flag = GridData[IndexofSelect].DBFLAG;
    if (flag === "U" || flag === "R") {
      TabData[IndexofSelect].DBFLAG = "D";
    } else if (flag === "I") {
      TabData = GridData.filter((obj, index) => index !== IndexofSelect);
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      setIndexofSelect(0);

    }

    setGridData(TabData);
    setopenDialog(false);

  }

  const handleClickCancel = () => {
    setAllButtonDisabled(false);
    setAllTextDisabled(true);

    if (GridData.length > 1) {
      if (IndexofSelect === 1) {
        settingValue();
      }
      setIndexofSelect(1);
    } else {
      if (IndexofSelect === 0) {
        settingValue();
      }
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      setIndexofSelect(0);
    }
  };

  const handleClickCancelButton = () => {
    if (PartyId === -1) {
      fetchPartyData(1, "L");
    } else {
      Mode === "view" && UnLock(PartyId, "MstParty", "PartyId");
      fetchPartyData(PartyId, "R");
    }
    setActiveStep(0);
  }

  return (
    <Grid container spacing={2}>
      {/* <ToastContainer /> */}
      <Dialog
        open={openDialog}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCancel}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item xs={12} sx={{ maxHeight: '140px', overflowY: 'scroll', padding: '16px' }} >
        <Paper
          sx={{
            width: "90%",
            overflow: "hidden",
            margin: "0px 0px 0px 50px",
            border: "1px solid lightgray",
          }}
        >
          <TableContainer sx={{ maxHeight: 450 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ "& > th": { padding: "2px 10px" } }}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <Typography variant="subtitle1" fontWeight="bold">
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {GridData.map((row, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      "& > td": { padding: "2px 14px" },
                      cursor: "pointer",
                    }}
                    onClick={() => handleRowClick(index)}
                  >
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value || "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
      {/* Buttons */}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginTop: "-10px",
          paddingRight: "100px",
        }}
      >
        <Box sx={{
          marginLeft: "50px"
        }}>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={AllButtonDisabled && AddDisabled || !AllButtonTextDisabled}
            onClick={handleClickAdd}
          >
            <AddIcon />
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
            disabled={AllButtonDisabled || !AllButtonTextDisabled}
            onClick={handleClickEdit}
          >
            <EditIcon />
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={AllButtonDisabled || !AllButtonTextDisabled}
            onClick={handleDelete}
          >
            <DeleteIcon />
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={!AllButtonDisabled || !AddDisabled}
            onClick={handleClickConfirm}
          >
            Confirm
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
            disabled={!AllButtonDisabled || !AddDisabled}
            onClick={handleClickCancel}
          >
            Cancel
          </Button>
        </Box>
      </Grid>

      {/* Form Section */}
      <Grid container spacing={0.5} sx={{ padding: '10px' }}>
        {/* Left Side: Text fields */}
        <Grid item xs={12} md={8}>
          <Box display="flex" flexDirection="column" gap={0.4}>
            <Grid container spacing={0.5}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Party Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="Addr"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('Addr') || ''}
                  {...register('Addr')}
                  disabled={AllTextDisabled}

                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  // label="Short Name"
                  label={
                    <span>
                      Party Abrv
                    </span>
                  }
                  name="PartyAbrv"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('PartyAbrv') || ''}
                  {...register('PartyAbrv')}
                  disabled={AllTextDisabled}


                />
              </Grid>

            </Grid>

            <Grid container spacing={0.5}>


              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  // label="Short Name"
                  label={
                    <span>
                      Alt Code
                    </span>
                  }
                  name="PartyAltCode"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('PartyAltCode') || ''}
                  {...register('PartyAltCode')}
                  disabled={AllTextDisabled}


                />
              </Grid>


              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={
                    "GST No"
                  }
                  name="GsttinNo"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('GsttinNo') || ''}
                  {...register('GsttinNo')}
                  disabled={AllTextDisabled}


                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="areaName-select-label">Company  <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="CoMstId"
                    name="CoMstId"
                    value={watch('CoMstId') || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register("CoMstId")}
                  >

                    {Company.length > 0 && Company.map(obj =>
                      <MenuItem value={obj.Id} key={obj.Id} >
                        {obj.Name}
                      </MenuItem>

                    )}


                  </Select>
                </FormControl>
              </Grid> */}


              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      PinCode <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="Pincode"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('PinCode') || ''}
                  {...register("PinCode", { onChange: handlePincodeChange })}
                  disabled={AllTextDisabled}

                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="areaName-select-label">Area  <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="PinId"
                    name="PinId"
                    value={watch('PinId') || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register("PinId", { onChange: handlePinIdChange })}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200, // Set the maximum height for the dropdown menu
                          overflow: 'auto', // Allow scrolling if content exceeds the max height
                        },
                      },
                    }}
                  >

                    {PinCity.length > 0 ? (
                      PinCity.map((obj) => (
                        <MenuItem
                          key={obj.Id}
                          value={obj.Id}
                        >
                          {obj.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        No areas available
                      </MenuItem>
                    )}

                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label={
                    "City"
                  }
                  name="City"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('City') || ''}
                  {...register('City')}
                  disabled={AllTextDisabled}

                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label={
                    "State"
                  }
                  name="State"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('State') || ''}
                  {...register('State')}
                  disabled={AllTextDisabled}

                />
              </Grid>





            </Grid>








          </Box>
        </Grid>

        {/* Right Side: File upload */}
        <Grid
          item
          lg={4}
          md={4}
          xs={12}
          display="flex"

          justifyContent="center"

        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            border="1px solid #ccc"
            borderRadius={1}
            width={130}
            height={140}
            overflow="hidden"
            position="relative"
            sx={{ cursor: "pointer", marginTop: "-10px" }}
          >
            {true ? (
              <img
                src={``}
                alt="Uploaded Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <Typography variant="body2" color="textSecondary">
                Browse
              </Typography>
            )}

            <input
              id="upload-photo"
              type="file"
              accept="image/*"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
              }}

            />
          </Box>
          <label htmlFor="upload-photo">
            <Button
              component="span"
              style={{ marginTop: '5px' }}
            >
              Upload Image
            </Button>
          </label>
        </Grid>


        {/* <Grid container xs={12} md={8} spacing={0.5} sx={{ border: 1, borderColour: "black", paddingLeft: "8px" }}>
          <Grid item xs={12} md={3} sx={{ border: 1, borderColour: "black", paddingLeft: "8px" }}>
            <TextField
              fullWidth
              label="PAN No"
              name="PanNo"
              variant="filled"
              className="custom-textfield"
              value={watch('PanNo') || ''}
              {...register('PanNo')}
              disabled={AllTextDisabled}

            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="TAN No"
              name="TanNo"
              variant="filled"
              className="custom-textfield"
              value={watch('TanNo') || ''}
              {...register('TanNo')}
              disabled={AllTextDisabled}

            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="IE Code"
              name="IeCode"
              variant="filled"
              className="custom-textfield"
              value={watch('IeCode') || ''}
              {...register('IeCode')}
              disabled={AllTextDisabled}

            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Website"
              name="Website"
              variant="filled"
              className="custom-textfield"
              value={watch('Website') || ''}
              {...register('Website')}
              disabled={AllTextDisabled}
            />
          </Grid>

          <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Tel No"
                  name="TelNo"
                  variant="filled"

                  className="custom-textfield"
                  value={watch('TelNo') || ''}
                  {...register('TelNo')}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Email"
                  name="Email"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('Email') || ''}
                  {...register('Email')}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Contact Person"
                  name="ContactPerson"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('ContactPerson') || ''}
                  {...register('ContactPerson')}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Mobile No"
                  name="MobileNo"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('MobileNo') || ''}
                  {...register('MobileNo')}
                  disabled={AllTextDisabled}
                />
              </Grid>
        </Grid> */}

        <Grid container md={12} xs={12} sx={{ marginTop: "2px", padding: "5px" }} >

          <Grid container md={8} xs={12} rowSpacing={0.5} columnSpacing={0.5}  >

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="PAN No"
                name="PanNo"
                variant="filled"
                className="custom-textfield"
                value={watch('PanNo') || ''}
                {...register('PanNo')}
                disabled={AllTextDisabled}

              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="TAN No"
                name="TanNo"
                variant="filled"
                className="custom-textfield"
                value={watch('TanNo') || ''}
                {...register('TanNo')}
                disabled={AllTextDisabled}

              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="IE Code"
                name="IeCode"
                variant="filled"
                className="custom-textfield"
                value={watch('IeCode') || ''}
                {...register('IeCode')}
                disabled={AllTextDisabled}

              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Website"
                name="Website"
                variant="filled"
                className="custom-textfield"
                value={watch('Website') || ''}
                {...register('Website')}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Tel No"
                name="TelNo"
                variant="filled"

                className="custom-textfield"
                value={watch('TelNo') || ''}
                {...register('TelNo')}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Email"
                name="Email"
                variant="filled"
                className="custom-textfield"
                value={watch('Email') || ''}
                {...register('Email')}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Contact Person"
                name="ContactPerson"
                variant="filled"
                className="custom-textfield"
                value={watch('ContactPerson') || ''}
                {...register('ContactPerson')}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Mobile No"
                name="MobileNo"
                variant="filled"
                className="custom-textfield"
                value={watch('MobileNo') || ''}
                {...register('MobileNo')}
                disabled={AllTextDisabled}
              />
            </Grid>


          </Grid>


          <Grid container xs={12} md={4} spacing={0} >
            <TextField
              fullWidth
              label="Work Address"
              name="WorkAdd"
              multiline
              rows={2}
              variant="filled"
              value={watch('WorkAdd') || ''}
              {...register('WorkAdd')}
              className="custom-textfield"
              sx={{
                '& .MuiInputBase-root': {
                  height: '89px',
                  marginLeft: "7px"

                },
                '& .MuiInputBase-input': {
                  resize: 'vertical',
                  marginTop: "10px"
                },
                '& .MuiFilledInput-root': {
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  '&.Mui-focused': {
                    backgroundColor: 'transparent',
                  },
                },
              }}
              disabled={AllTextDisabled}
            />
          </Grid>
        </Grid>



        {/* <Grid item display="flex" alignItems="center">

          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Work Address"
                  name="WorkAdd"
                  multiline
                  rows={2}
                  variant="filled"
                  className="custom-textfield"
                  value={watch('WorkAdd') || ''}
                  {...register('WorkAdd')}
                  disabled={AllTextDisabled}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '100px',
                      width: '300px'
                    },
                    '& .MuiInputBase-input': {
                      resize: 'vertical',
                    },
                    '& .MuiFilledInput-root': {
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-focused': {
                        backgroundColor: 'transparent',
                      },
                    },
                  }}
                />
              </Grid>

            </Grid>
          </Box>

        </Grid> */}

        <Grid item lg={12} md={12} xs={12}>

          <Box display="flex" flexDirection="column" gap={1}>
            <Grid container spacing={1}>

              <Grid item xs={12} md={2} className='form_field'>

                <TextField
                  fullWidth
                  label="MSME No"
                  name="MsmeNo"
                  variant="filled"
                  className="custom-textfield"
                  value={watch('MsmeNo') || ''}
                  {...register('MsmeNo')}
                  disabled={AllTextDisabled}
                />

              </Grid>

              <Grid item xs={12} md={2} className='form_field'>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="areaName-select-label">MSME Act</InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="MsmeAct"
                    name="MsmeAct"
                    value={watch('MsmeAct') || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register('MsmeAct')}
                  >
                    <MenuItem value={"N"}>Not Register</MenuItem>
                    <MenuItem value={"M"}>Mfr</MenuItem>
                    <MenuItem value={"T"}>Trader</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={2} className='form_field'>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="areaName-select-label">MSME Trade</InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="MsmeTr"
                    name="MsmeTr"
                    value={watch('MsmeTr') || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register('MsmeTr')}
                  >
                    <MenuItem value={"N"}>Not Register</MenuItem>
                    <MenuItem value={"G"}>Goods</MenuItem>
                    <MenuItem value={"S"}>Service</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2} className='form_field'>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="areaName-select-label">MSME Class</InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="MsmeClass"
                    name="MsmeClass"
                    value={watch('MsmeClass') || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register('MsmeClass')}
                  >
                    <MenuItem value={"N"}>Not Register</MenuItem>
                    <MenuItem value={"M"}>Medium</MenuItem>
                    <MenuItem value={"M"}>Micro/Small</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Remark"
                  name="Remark"
                  multiline
                  rows={1}
                  variant="filled"
                  className="custom-textfield"
                  value={watch('Remark') || ''}
                  {...register('Remark')}
                  disabled={AllTextDisabled}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '45px',

                    },
                    '& .MuiInputBase-input': {
                      resize: 'vertical',
                      marginTop: "10px"
                    },
                    '& .MuiFilledInput-root': {
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-focused': {
                        backgroundColor: 'transparent',
                      },
                    },
                  }}
                />
              </Grid>

            </Grid>
            <Box>
              <Grid container spacing={1}>


              </Grid>
            </Box>

          </Box>

        </Grid>

      </Grid>
      <Grid
        item
        xs={2}
        className="form_button"
        sx={{
          display: "flex",
          gap: "10px",
          alignItems: "center",

          marginLeft: "69vw",
          textAlign: "right",

        }}
      >
        {['Prev', 'Submit', 'Cancel'].map((label, index) => (
          <Button
            key={index}
            sx={{ background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', width: "50px" }}
            variant="contained"
            onClick={label === 'Prev' ? handlePreviousClick : label === 'Submit' ? handleSubmit : handleClickCancelButton}
            disabled={!AllButtonTextDisabled}
          >
            {label}
          </Button>
        ))}
      </Grid>


    </Grid >

  )
}

export default PartyStepper2
